import { useUserInfo } from "@/api/user";
import { AccountPopover } from "@/components/AccountPopover/AccountPopover";
import { AccountPopoverRailFooterTrigger } from "@/components/AccountPopover/AccountPopoverRailFooterTrigger";
import { TrialStatusCard } from "@/components/billing/TrialStatusCard";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { ROUTES } from "@/constants/routes";
import { useOpenSettings } from "@/context/OpenSettingsContext";
import { useBreakpoint } from "@/hooks/useBreakpoint";
import { isNativePlatform } from "@/native/platform";
import { setFullAppOverride } from "@/pages/mobile/fullAppOverride";
import { Settings, Smartphone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ModelMenu } from "./ModelMenu";

export function WorkspaceSidebarFooter() {
  const openSettings = useOpenSettings();
  const navigate = useNavigate();
  const { data: userInfo } = useUserInfo();
  const email = userInfo?.user?.email;
  // Desktop: the avatar slot is a ghost box — PersistentRailAvatar pins the
  // one real avatar over it from outside the rail's clip (DS 021), and the
  // quick-nav flies out RIGHT of the pane edge, bottom-aligned (DS §12).
  // Mobile's overlay drawer has no collapse, so it keeps a real avatar.
  const lg = useBreakpoint("lg");

  return (
    <div className="border-t border-n-10">
      <TrialStatusCard />
      <div className="flex items-center gap-2 px-3 py-2.5">
        <Tooltip>
          <AccountPopover
            popoverSide={lg ? "right" : "top"}
            popoverAlign={lg ? "end" : undefined}
          >
            <TooltipTrigger asChild>
              <AccountPopoverRailFooterTrigger ghostAvatar={lg} />
            </TooltipTrigger>
          </AccountPopover>
          {email ? (
            <TooltipContent side="top" align="start">
              {email}
            </TooltipContent>
          ) : null}
        </Tooltip>

        <div className="flex shrink-0">
          <ModelMenu />
        </div>

        {isNativePlatform() && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-label="Mobile home"
                onClick={() => {
                  setFullAppOverride(false);
                  navigate(ROUTES.HOME);
                }}
                className="inline-flex size-8 shrink-0 items-center justify-center rounded-md text-n-50 outline-none transition-colors hover:bg-n-05 hover:text-n-80 focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-rust focus-visible:outline-offset-[-2px]"
              >
                <Smartphone className="size-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="top">Mobile home</TooltipContent>
          </Tooltip>
        )}

        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label="Settings"
              onClick={() => openSettings(ROUTES.SETTINGS.PROFILE)}
              className="inline-flex size-8 shrink-0 items-center justify-center rounded-md text-n-50 outline-none transition-colors hover:bg-n-05 hover:text-n-80 focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-rust focus-visible:outline-offset-[-2px]"
            >
              <Settings className="size-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top">Settings</TooltipContent>
        </Tooltip>
      </div>
    </div>
  );
}
